// extracted by mini-css-extract-plugin
module.exports = {"root":"App_root__1Bb5Q","content":"App_content__3vLF1"};